// @flow

import React, { type ComponentType } from 'react';
import { connect } from 'react-redux';
import type { Dispatch } from 'redux';
import type { State } from 'app/common/redux/types';
import { OpenLoginModal } from 'app/common/redux/actions/login';

type ReduxStateProps = {|
  isAuth: boolean,
  isLimitedLogin: boolean,
|};

type ReduxDispatchProps = {|
  dispatch: Dispatch<any>,
|};

type Props = {|
  ...ReduxDispatchProps,
  ...ReduxStateProps,
|};

const mapStateToProps = (state: State): $Exact<ReduxStateProps> => ({
  isLimitedLogin: state.viewer.isLimitedLogin,
  isAuth: state.viewer.isAuth,
});

// $FlowFixMe Flow v0.104.0 upgrade supression.
export default function withAuthenticatedAction(Subject: ComponentType<*> | ((props: *) => *)) {
  const AuthenticatedAction = (props: Props) => {
    const { dispatch, isAuth, isLimitedLogin } = props;

    const authAction =
      !isAuth || isLimitedLogin
        ? // $FlowFixMe: new errors found from flow 0.96 upgrade
          (fn) => (evt) => {
            if (evt) {
              // $FlowFixMe: new errors found from flow 0.96 upgrade
              evt.stopPropagation();
            }
            dispatch(OpenLoginModal);
          }
        : (fn) => fn;

    return <Subject authAction={authAction} {...props} />;
  };

  AuthenticatedAction.displayName = `WithAuthenticatedAction(${String(
    Subject.displayName || Subject.name,
  )})`;

  return connect<Props, {}, _, _, _, _>(mapStateToProps)(AuthenticatedAction);
}
